import { IWidgetComponentProps, getWidgetProps } from '@framework/engine';
import { useWatch } from 'react-hook-form';
import { isOmissisEnabled } from '../../directives/omissis/OmissisDirective.type';
import { IUploadWidget, UploadButtonsLayout } from './IUploadWidget';
import { publicDataUploadWidgetName } from './UploadWidget.type';
import { ButtonsLayout } from './components/ButtonsLayout';
import { UploadWidgetComponentInput } from './components/UploadWidgetComponentInput';

export interface IUploadWidgetComponentProps
  extends IWidgetComponentProps<IUploadWidget> {}

/**
 * Per la gestione dell'upload in caso di omissis abilitato, dobbiamo
 * comunque passare lo **Stesso** id sia per il campo privato che per
 * il campo pubblico, al backend.
 */
function useAttachmentUniqueId(props: IUploadWidgetComponentProps) {
  const options = getWidgetProps(props);
  const privateIdFieldName = options.name;
  const publicIdFieldName = publicDataUploadWidgetName(options.name);
  const [privateId, publicId] = useWatch({
    name: [privateIdFieldName, publicIdFieldName],
  });
  return privateId || publicId;
}

export function UploadWidgetComponent(props: IUploadWidgetComponentProps) {
  const publicUpload = isOmissisEnabled(props.widget);

  const attachmentUniqueId = useAttachmentUniqueId(props);

  return (
    <ButtonsLayout
      hasOmissis={publicUpload}
      horizontal={
        props.widget.layout?.buttonLayout == UploadButtonsLayout.Horizontal
      }
    >
      <UploadWidgetComponentInput
        {...props}
        attachmentUniqueId={attachmentUniqueId}
      />
      {publicUpload && (
        <UploadWidgetComponentInput
          {...props}
          publicUpload
          attachmentUniqueId={attachmentUniqueId}
        />
      )}
    </ButtonsLayout>
  );
}
